import { render, staticRenderFns } from "./multipane.vue?vue&type=template&id=3d532383"
import script from "./multipane.vue?vue&type=script&lang=ts"
export * from "./multipane.vue?vue&type=script&lang=ts"
import style0 from "./multipane.vue?vue&type=style&index=0&id=3d532383&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports